import React from 'react';
import { makeStyles } from '@mui/styles';
import { Typography, Box, Divider } from '@mui/material';

const useStyles = makeStyles(() => ({
    header: {
        opacity: 1,
        color: 'rgba(31,78,146,1)',
        fontFamily: 'SFProDisplay-Bold',
        fontSize: '18px',
        fontWeight: 700,
        fontStyle: 'normal',
        letterSpacing: '0px',
        textAlign: 'left',
    },
    description: {
        opacity: 1,
        color: 'rgba(125,125,125,1)',
        fontFamily:
            "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
        fontSize: '13px',
        fontWeight: 700,
        fontStyle: 'normal',
        letterSpacing: '0px',
        textAlign: 'left',
    },
    noPaddingLeft: {
        paddingLeft: 0,
    },
}));

const PageSection = ({ headerText, descriptionText, children }) => {
    const classes = useStyles();

    return (
        <Box sx={{ padding: '24px' }}>
            <Divider
                textAlign="left"
                variant="string"
                sx={{
                    '::before': {
                        width: 0,
                    },
                    '&&& span': {
                        paddingLeft: 0,
                    },
                }}
            >
                <Typography
                    variant="h5"
                    style={{
                        opacity: 1,
                        color: 'rgba(31,78,146,1)',
                        fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
                        fontSize: '18px',
                        fontWeight: 700,
                        fontStyle: 'normal',
                        letterSpacing: '0px',
                        textAlign: 'left',
                    }}
                >
                    {headerText}
                </Typography>
            </Divider>
            <Typography
                variant="body1"
                style={{
                    marginTop: '8px',
                    fontWeight: 600,
                    opacity: 1,
                    color: 'rgba(125,125,125,1)',
                    fontFamily:
                        "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
                    fontSize: '13px',
                    fontStyle: 'normal',
                    letterSpacing: '0px',
                    textAlign: 'left',
                }}
                className={classes.description}
            >
                {descriptionText}
            </Typography>
            <Box sx={{ marginTop: '16px' }}>{children}</Box>
        </Box>
    );
};

export default PageSection;
